import * as React from "react";
import { FC } from "react";
import WPracowni from "./w_pracowni";

export default (): FC => <WPracowni />;
